import headerMixin from '@/mixins/headerMixin';
import pageNotFound from '@/mixins/pageNotFound';
import { ResourceType } from '@/types/resources';

export default {
  mixins: [headerMixin, pageNotFound],
  computed: {
    favourites() {
      return this.$store.getters.getFavourites || [];
    },

    bookmarkingDisabled() {
      return (
        this.isNewPage ||
        this.isNewBoard ||
        this.pageNotFound ||
        this.page?.archived?.time_archived != null ||
        this.board?.archived
      );
    },
  },
  methods: {
    toggleBookmark(resource, type) {
      if (this.bookmarkingDisabled || !resource) return;

      if (type === ResourceType.NoteTemplate) {
        this.toggleFavourite(resource);
        return;
      }

      if (this.isFavourite(resource.id, type)) {
        this.removeFromFavourites(resource, type);
        this.clearFavourites();
        return;
      }

      const memberName =
        resource?.display_name || `${resource?.first_name || ''} ${resource?.last_name || ''}`;
      this.addToFavourite(resource, type, memberName);
    },

    clearFavourites() {
      this.$store.dispatch('setFavouritesOpened', false);
      this.$store.dispatch('setOpenedFavouriteItem', {});
    },

    addToFavourite(resource, type, memberName) {
      this.$store.dispatch('addFavourite', {
        resource_id: resource.id,
        resource_type: type,
        title: resource.title || resource.name || memberName,
        ...(resource.state && {
          state: resource.state,
          project_id: resource.project_id,
        }),
      });
    },

    removeFromFavourites(resource, type) {
      this.$store.dispatch('deleteUserFavourite', {
        resource_id: resource.id,
        resource_type: type,
        title: resource.title || resource.name,
        ...(resource.state && {
          state: resource.state,
          project_id: resource.project_id,
        }),
      });
    },

    isFavourite(resourceId, type) {
      return this.$store.getters.isFavourite(resourceId, type);
    },

    toggleFavourite(resource) {
      const { is_favourited } = resource;
      this.$store.dispatch(
        is_favourited ? 'unfavouriteNoteTemplate' : 'favouriteNoteTemplate',
        resource
      );
    },
  },
};
